import omit from 'lodash-es/omit';
import { PersistedStateKeys } from 'shared/enums/PersistedStateKeys';
import { IChannelDraft } from '../interfaces/IChannelDraft';

const removeExpiredConversationDrafts = (): void => {
  const drafts: Record<string, IChannelDraft> = JSON.parse(
    localStorage.getItem(PersistedStateKeys.ConversationDrafts) || '{}',
  );
  const twoWeeksAgo = Date.now() - 1209600000;
  for (const id in drafts) {
    const draft = drafts[id];
    if (!draft.timestamp || (draft.timestamp && draft.timestamp < twoWeeksAgo)) {
      localStorage.setItem(PersistedStateKeys.ConversationDrafts, JSON.stringify(omit(drafts, id)));
    }
  }
};

export default removeExpiredConversationDrafts;
